import MuiButton from "@mui/material/Button";
import styled from "styled-components";

type StyledButtonProps = {
  textcolor: string;
  iscta?: string;
  fontFamily?: "NotoSans-SemiBold" | "NotoSans-Medium" | "Outfit-SemiBold";
  fontSize?: string;
};
const StyledButton = styled(MuiButton)<StyledButtonProps>`
  && {
    text-transform: none;
  }
  width: 100%;
  height: 40px;
  padding: 0px 16px 0px 16px;
  border-radius: 6px;
  z-index: 3;
  gap: 8px;
  color: ${(props: StyledButtonProps) => props.textcolor};
  font-size: ${(props: StyledButtonProps) =>
    props.iscta ? "88%" : props.fontSize};
  font-family: ${(props: StyledButtonProps) =>
    props.iscta ? "Outfit-SemiBold" : props.fontFamily};
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;
export default StyledButton;
